// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getStringKeyAndNumberValueArrayFromEnum(enumObject: any): { key: string; value: number }[] {
  return Object.values(enumObject)
    .map((item) => Number(item))
    .filter((item) => !isNaN(item))
    .map((value) => {
      return { key: enumObject[value], value: value };
    });
}
